import type { ZipCodeInfoAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type GroupBy,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryOrderToSQL,
} from './common'

const ZipCodeInfoQ = {
  ...makeQueryModelV2<ZipCodeInfoAttributes>('zip_code_info')([
    'id',
    'zip_code',
    'state',
    'details',
    'created_at',
    'updated_at',
    'deleted_at',
  ]),

  where: (
    {
      id = null,
      zipCode = null,
      groupBy = null,
      order = null,
      paranoid = true,
    }: {
      id?: number | null | SQLFragment<number>
      zipCode?: string | null | SQLFragment<string>
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      paranoid?: boolean
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<ZipCodeInfoAttributes> => SQL`
        FROM ${ZipCodeInfoQ}
        WHERE
            ${id != null ? SQL`${ZipCodeInfoQ.id} = ${id} AND` : SQL``}
            ${zipCode != null ? SQL`${ZipCodeInfoQ.zip_code} = ${zipCode} AND` : SQL``}
            ${paranoid ? SQL`${ZipCodeInfoQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
    `,
}

export default ZipCodeInfoQ
